import React from 'react';
import { Card, Row, Col, Button } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import DetailItem from '../../../../CSIComponents/DetailItem';
import { ClockCircleOutlined } from '@ant-design/icons';
import { Moment } from 'moment';
interface propsTypes {
  cancellationDetails:{
    policycode?:string | null,
    deadlinetype?:string | null,
    timeunit?:string | null,
    noofunits?:string | null,
    cancelmethod?:string | null,
    cancelTime?: Moment
  },
  toggleToEditMode: void | any,
  setActiveTabKey: void | any
}
const UNITTIME = 'Time Unit'
const DeadLineDetail = (props: propsTypes) => {

    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('Cancellation') }}>Back</Button>
                    </div>
                    <div>
                        <Button type="primary" className="db-edit-btn" onClick={props.toggleToEditMode}>Edit</Button>
                    </div>
                </div>
    } 

    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }} title={props.cancellationDetails?.policycode} extra={edit()}>
                <div style={{ padding: "0 20px" }}>
                    <Row gutter={24}>
                      <Col span={6} className="col-margin">
                        <DetailItem value={props?.cancellationDetails?.deadlinetype} label="Deadline Type" />
                      </Col>
                      {
                        props?.cancellationDetails?.deadlinetype === UNITTIME?
                          <>
                              <Col span={6} className="col-margin">
                                  <DetailItem value={props?.cancellationDetails?.timeunit} label="Time Unit" >
                                      <ClockCircleOutlined />
                                  </DetailItem>
                              </Col>
                              <Col span={6} className="col-margin">
                                  <DetailItem value={props?.cancellationDetails?.noofunits} label="Number of Units" />
                              </Col>
                              <Col span={6}></Col>
                              <Col span={6} className="col-margin">
                                  <DetailItem value={props?.cancellationDetails?.cancelmethod} label="Cancellation Method" />
                              </Col>
                          </> :
                          <Col span={6} className="col-margin">
                            <DetailItem value={props?.cancellationDetails?.cancelTime?.format('HH:mm')} label="Cancel Time" />
                        </Col>
                      }
                       
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default DeadLineDetail;

